import { isArray, isFunction } from 'lodash';
import { checkIsRunning, getInitChain, store as getStore } from '@mews-commander/legacy-app-instance';
import { logSentryError } from '@mews/framework';

export const createRun = () => {
    let loadRenderer: (...args: unknown[]) => unknown;

    const run = async (dependencies = [], task: $TSFixMe) => {
        checkIsRunning();

        // Support shortcut call without dependencies.
        if (isFunction(dependencies)) {
            return run([], dependencies);
        }

        if (!isArray(dependencies)) {
            throw new TypeError('Expected dependencies to be an array.');
        }

        if (!isFunction(task)) {
            throw new TypeError('Expected task to be a function.');
        }

        const initChain = getInitChain();

        const { dispatch } = getStore();

        if (!loadRenderer) {
            const { createRendererLoader } = await import(
                /* webpackChunkName: "backendRenderers", webpackPrefetch: true */ './loadRenderer'
            );
            loadRenderer = createRendererLoader();
        }
        const modules = dependencies.map(loadRenderer);
        initChain.then(() => task(...modules)).catch((error: $TSFixMe) => dispatch(logSentryError({ error })));
    };

    return run;
};
